import React, { useEffect, useState } from 'react'

import { getAccountConsent } from '../../../../api'
import { Consent } from '../../../../api/AccountConsent/getAccountConsents'
import { setUnexpiredConsentCookie, shouldPreventApiThrottling } from '../../../../core/pure/Cookie'
import { DialogProvider } from '../Dialog/DialogProvider'
import { consentCookieIsExpired, getConsentCookie, writeToBeRequestedConsentThatHaveNoCookie } from './pure'

type ConsentProviderProps = {
  accountId: string
}

export const ConsentProvider: React.FC<ConsentProviderProps> = ({ accountId }) => {
  const [consent, setConsent] = useState<Consent | null>(null)

  useEffect(() => {
    ;(async () => {
      const accountConsent = await getAccountConsent(accountId)

      writeToBeRequestedConsentThatHaveNoCookie(accountConsent, accountId)

      if (shouldPreventApiThrottling(accountConsent, accountId)) {
        setUnexpiredConsentCookie(accountId)
      }
      if (
        Boolean(getConsentCookie(accountConsent.id, accountId)) &&
        consentCookieIsExpired(accountConsent.id, accountId)
      ) {
        setConsent(accountConsent)
      }
    })()
  }, [])

  if (!consent) return null

  return <DialogProvider consent={consent} accountId={accountId} />
}
